import { createFileRoute } from '@tanstack/react-router'
import { JobsPage } from '@/pages/administration/administration-page'

export const Route = createFileRoute('/administration/jobs')({
  component: JobsPage,
})
